import React, { Suspense, lazy } from 'react'
import {BrowserRouter as Router, Routes, Route, Navigate, useParams, useLocation} from 'react-router-dom'

import Home from "./Home";
import About from "./About";
import News from "./News";
import Contact from "./Contact";
import NewsDetails from "./news-details";
import Faq from "./faq";
import History from "./history";
import Price from "./price";

import Services from './services';
import ServiceDetails from './services-details';

import TextLinkService from '../TextLinkPages/Services/TextLinkService';
import UseYourOwnNumbers from '../TextLinkPages/Services/UseYourOwnNumbers';
import SmsApi from '../TextLinkPages/Tools/SMS Api/SmsApi';
import BulkSmsApi from '../TextLinkPages/Tools/SMS Api/BulkSmsApi';
import VerificationApi from '../TextLinkPages/Tools/SMS Api/VerificationApi';
import AdvancedBulkSms from '../TextLinkPages/Tools/No-Code/AdvancedBulkSms';
import ServicesOverview from '../TextLinkPages/Services/ServicesOverview';
import ToolsOverview from '../TextLinkPages/Tools/ToolsOverview';
import UseYourOwnNumbersPricing from '../TextLinkPages/Services/UseYourOwnNumbersPricing';
import SellRegular from '../TextLinkPages/SellSMS/SellRegular';
import SellForProviders from '../TextLinkPages/SellSMS/SellForProviders';
import LoginPage from '../TextLinkPages/LogReg/LoginPage';
import RegisterPage from '../TextLinkPages/LogReg/RegisterPage';
import SignIn from '../TextLinkPages/LogReg/SignIn';
import SignUp from '../TextLinkPages/LogReg/Signup';
import TextLinkServicePricing from '../TextLinkPages/Services/TextLinkServicePricing';
import ForgotPassword from '../TextLinkPages/LogReg/ForgotPassword';
import ResetPassword from '../TextLinkPages/LogReg/ResetPassword';
import Tos from '../TextLinkPages/Tos/Tos';
import PrivacyPolicy from '../TextLinkPages/Tos/PrivacyPolicy';
import DownloadApp from '../TextLinkPages/Other/DownloadApp';
import TruckingDispatch from '../TextLinkPages/Industries/TruckingDispatch';
import Marketing from '../TextLinkPages/Industries/Marketing';
import WebTextingApp from '../TextLinkPages/Tools/WebTextingApp';
import SAAS from '../TextLinkPages/Industries/SAAS';
import VerifySubuser from '../TextLinkPages/LogReg/VerifySubuser';
import ProductComparisonTable from '../TextLinkPages/Other/ProductComparisonTable';
import Cookies from '../TextLinkPages/Tos/Cookies';
import SignUpAppSumo from '../TextLinkPages/LogReg/SignUpAppSumo';
import BlogPages from '../TextLinkPages/Blog/BlogPages';
import BlogPost from '../TextLinkPages/Blog/BlogPost';
import SetupGHL from '../TextLinkPages/GHL/SetupGHL';
import GhlExplenation from '../TextLinkPages/GHL/GhlExplenation';
import HowItWorks from '../TextLinkPages/HowItWorks/HowItWorks';
import AffiliatePage from '../TextLinkPages/Affiliate/AffiliatePage';
import AffiliateProgram from '../TextLinkPages/Affiliate/AffiliateProgram';
import GhlPromo from '../TextLinkPages/GHL/GhlPromo';
import Roadmap from './Roadmap';
import RecommendedSetup from '../TextLinkPages/Other/RecommendedSetup';

// Code-split the dashboard out of the main bundle. The whole dashboard
// (charts, kanban, file manager, rich-text editors, etc.) was previously
// loaded eagerly on every landing page — that's what blew the main.js
// up to ~12MB and tanked mobile LCP. With React.lazy + conditional
// rendering, the dashboard chunk is only fetched when the user actually
// navigates to a dashboard / auth route.
//
// IMPORTANT: lazy-load `Admin` (not `RouterAdmin` directly) because
// Admin.js imports the dashboard SCSS files as side effects:
//   import "./assets/scss/dashlite.scss";
//   import "./assets/scss/style-email.scss";
// Lazy-loading Admin pulls those stylesheets into the dashboard chunk;
// lazy-loading RouterAdmin alone leaves the dashboard unstyled.
const Admin          = lazy(() => import('../Dashboard/Admin'));
const PaymentSuccess = lazy(() => import('../Dashboard/pages/Pricing/PaymentSuccess'));

// Redirects /blogs/:slug → /:slug so old inbound links keep working.
function RedirectBlogPost() {
  const { slug } = useParams();
  return <Navigate to={`/${slug}`} replace />;
}

function Landing(){
  const location = useLocation();
  const isDashboard = location.pathname.startsWith("/dashboard");
  return(

    <Routes>
                <Route path="/" element={<Home />}></Route>

                <Route path="/how-textlink-works" element = {<HowItWorks/>}></Route>
                <Route path="/recommended-setup" element={<RecommendedSetup />}></Route>
                <Route path="/affiliate-program" element = {<AffiliateProgram/>}></Route>
                <Route path="/setup-1" element={<SetupGHL />}></Route>
                <Route path="/textlink-ghl-integration" element={<GhlExplenation />}></Route>

                <Route path="/ghl" element={<GhlPromo />}></Route>
                <Route path="/roadmap" element={<Roadmap />}></Route>

                <Route path="/textlinkservice" element={<TextLinkService/>}></Route>
                <Route path="/selfhostedservice" element={<UseYourOwnNumbers />}></Route>

                <Route path="/smsapi" element={<SmsApi />}></Route>
                <Route path="/bulksmsapi" element={<BulkSmsApi />}></Route>
                <Route path="/verificationapi" element={<VerificationApi />}></Route>
                <Route path="/bulksms" element={<AdvancedBulkSms />}></Route>
                <Route path="/web-sms-app" element = {<WebTextingApp/>}/>

                <Route path="/affiliate/:code" element={<AffiliatePage />} />

                <Route path="/trucking" element={<TruckingDispatch />}></Route>
                <Route path="/sms-marketing" element={<Marketing />}></Route>
                <Route path="/saas" element={<SAAS/>}/>

                <Route path="/Contact" element={<Contact />}></Route>
                <Route path="/smsservicesoverview"   element={<ServicesOverview />}></Route>
                <Route path="/smstoolsoverview" element={<ToolsOverview />}></Route>
                <Route path="/payment-success" element={<Suspense fallback={null}><PaymentSuccess/></Suspense>}/>
                <Route path="/tos" element={<Tos/>}/>
                <Route path="/privacy-policy" element={<PrivacyPolicy/>}/>
                <Route path="/cookies" element={<Cookies />} />

                <Route path="/faq" element={<Faq />}></Route>
                <Route path="/download-app" element={<DownloadApp />}></Route>
                <Route path="/pricing" element={<UseYourOwnNumbersPricing />}></Route>
                <Route path="/services" element={<Services/>}></Route>
                <Route path="/services-details" element={<ServiceDetails/>}></Route>
                <Route path="/sms-product-comparasings" element={<ProductComparisonTable/>}/>

                <Route path="/about" element={<About/>}></Route>
                <Route path="/signin" element={<SignIn/>}/>
                <Route path="/signup" element={<SignUp/>}/>
                <Route path="/appsumo-signup" element={<SignUpAppSumo/>}/>
                <Route path="forgot-password" element={<ForgotPassword/>}/>
                <Route path="/auth/reset-password/:token" element={<ResetPassword />} />
                <Route path="/verify-subuser/:id/:token" element={<VerifySubuser />} />

                {/* Guides hub. /blogs and /blogs/:slug are kept as 301-style
                    redirects so any old inbound link or indexed URL resolves
                    to the new path without a 404. */}
                <Route path="/guides" element={<BlogPages/>}/>
                <Route path="/blogs" element={<Navigate to="/guides" replace />}/>
                <Route path="/blogs/:slug" element={<RedirectBlogPost />}/>
                {!isDashboard && <Route path="/:slug" element={<BlogPost />} />}

                </Routes>

  )
}

// Mounts the dashboard ONLY on routes that the dashboard's internal
// router actually handles. This includes /dashboard/* (the main app),
// /auth-* (login/register/reset/success — handled inside RouterAdmin
// via LayoutNoSidebar), and /errors/* (404/504 pages). Anything else
// is a public landing page and doesn't need the dashboard chunk.
function DashboardMount() {
  const location = useLocation();
  const path = location.pathname;
  const needsAdmin =
    path.startsWith('/dashboard') ||
    path.startsWith('/auth-')     ||
    path.startsWith('/errors');
  if (!needsAdmin) return null;
  return (
    <Suspense fallback={null}>
      <Admin />
    </Suspense>
  );
}

export default function RouterPage() {
  return (
    <div>
        <Router>
            <Landing/>
            <DashboardMount />
        </Router>
    </div>
  )
}
